<div class="container-fluid">
  <div class="row mb-3">
    <div class="col-md-4 offset-md-2">
      <div class="card mb-2">
        <div class="card-body">
          <h5 class="card-title">{{isRCDSS ? 'Contract' : 'Purchase Order'}} Details</h5>

          <div class="mb-1">
            <b>{{isRCDSS ? 'Contract' : 'Purchase Order'}} Number:</b>
            {{ purchaseOrderInfo.customer_po_number }}
          </div>

          <div class="mb-1">
            <b>Supplier:</b>
            {{ purchaseOrderInfo.supplier?.name }}
          </div>

          <div class="mb-1" *ngIf="purchaseOrderInfo.sales_order_number">
            <b>Sales Order Number:</b>
            {{ purchaseOrderInfo.sales_order_number }}
          </div>

          <div class="mb-1">
            <b>Priority:</b>
            {{ purchaseOrderInfo.priority?.name }}
          </div>

          <div class="mb-1">
            <b>Order Date:</b>
            {{ purchaseOrderInfo.order_date | date:'MM/dd/yyyy':'utc' }}
          </div>

          <div class="mb-1">
            <b>Ship Date:</b>
            {{ purchaseOrderInfo.ship_date | date:'MM/dd/yyyy':'utc' }}
          </div>

          <div class="mb-1">
            <b>Report Start Date:</b>
            {{ purchaseOrderInfo.report_start_date | date:'MM/dd/yyyy':'utc' }}
          </div>

          <div class="mb-1">
            <b>Cancel Date:</b>
            {{ purchaseOrderInfo.cancel_date | date:'MM/dd/yyyy':'utc' }}
          </div>

          <div>
            <b>Report Frequency:</b>
            {{ purchaseOrderInfo.finished_goods_reports_period }}
          </div>
        </div>
      </div>

      <div class="card mb-2">
        <div class="card-body">
          <h5 class="card-title">Line Items</h5>

          <div *ngFor="let item of purchaseOrderInfo.line_items">
            <strong>{{ item.product_name || displayProductName(item.product_id) }}</strong>
            <span>({{ item.quantity_ordered }} ordered)</span>
          </div>
        </div>
      </div>

      <div class="card mb-2" *ngIf="purchaseOrderFiles">
        <div class="card-body">
          <h5 class="card-title">Files</h5>

          <div *ngFor="let item of purchaseOrderFiles">
            <strong>{{ item.file_name }}</strong>
            <span>{{ item.file_size | fileSize }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="card mb-2">
        <div class="card-body">
          <h5 class="card-title">Task List</h5>
          <div *ngIf="checklist">
            <div class="border p-2 mb-1" *ngFor="let task of checklist.checklist_tasks">
              <span [style.font-size.px]=14>{{ task.name }}</span>
              <div>
                <span><u>Responsible:</u> {{ task.responsible_contact?.first_name | titlecase }} {{ task.responsible_contact?.last_name | titlecase }}</span>
                <span><u>Due Date:</u> {{ task.due_date | date:'MMM dd yyyy':'utc' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card mb-2">
        <div class="card-body">
          <h5 class="card-title">Subscribers</h5>

          <div class="row">
            <div class="col-6 p-2" *ngFor="let subscriber of getSubscribers()">
              <div class="border p-2">
                <span>{{ subscriber.first_name | titlecase }} {{ subscriber.last_name | titlecase }}</span>
                <br>
                <small>{{ subscriber.email }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
